import ProductFinderForm from '../../components/product-finder/ProductFinderForm'
import SuggestedRequestsList from '../../components/product-finder/SuggestedRequestsList'
import { useNavigate } from 'react-router-dom'
import { PRODUCT_FINDER_TABS } from '../../constants/productFinder'
import SeoHelmet from '../../components/common/SeoHelmet'

const ProductFinderPage = ({ activeTab }) => {
  const navigate = useNavigate()

  const isResponsesTab = activeTab === PRODUCT_FINDER_TABS.RESPONSES

  return (
    <div className="main-container py-8 min-h-screen">
      <SeoHelmet
        title={isResponsesTab ? 'Product Finder - Responses' : 'Product Finder'}
        description={
          isResponsesTab
            ? 'View responses to your product finder requests from Eastleigh retailers and wholesalers. Track your inquiries and connect with suppliers.'
            : "Can't find what you're looking for? Use our product finder to get quotes from verified retailers and wholesalers in Eastleigh marketplace."
        }
        keywords={
          isResponsesTab
            ? 'product finder responses, supplier quotes, retailer responses, product requests'
            : 'product finder, find products, request quotes, Eastleigh suppliers, product search'
        }
        url={isResponsesTab ? '/product-finder/responses' : '/product-finder'}
      />
      <div className="sticky top-0 z-10 bg-background shadow-sm">
        <div className="max-w-md lg:max-w-4xl mx-auto flex justify-start lg:justify-center border-b border-gray-200 gap-x-8">
          <button
            onClick={() => navigate('/product-finder')}
            className={`py-3 px-4 text-base font-semibold ${
              activeTab === PRODUCT_FINDER_TABS.FIND
                ? 'text-black border-b-2 border-secondary-600'
                : 'text-gray-500 border-b-2 border-transparent hover:text-gray-700 hover:border-gray-300'
            }`}
          >
            Find Your Product
          </button>
          <button
            onClick={() => navigate('/product-finder/responses')}
            className={`py-3 px-4 text-base font-semibold ${
              activeTab === PRODUCT_FINDER_TABS.RESPONSES
                ? 'text-black border-b-2 border-secondary-600'
                : 'text-gray-500 border-b-2 border-transparent hover:text-gray-700 hover:border-gray-300'
            }`}
          >
            Product Finder Responses
          </button>
        </div>
      </div>
      <div className="max-w-md lg:max-w-2xl mx-auto mt-5 lg:mt-8">
        {activeTab === PRODUCT_FINDER_TABS.FIND && <ProductFinderForm />}
        {activeTab === PRODUCT_FINDER_TABS.RESPONSES && <SuggestedRequestsList />}
      </div>
    </div>
  )
}

export default ProductFinderPage
